module.exports = __webpack_public_path__ + "static/media/cake.3711a3e4.jpg";